import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../contexts/DataContext';
import AdminLayout from '../../components/AdminLayout';

const HORARIOS = ['07:00','08:00','09:00','10:00','11:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00'];

const s = {
  header: { marginBottom: '32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  title: { fontFamily: "'Inter', sans-serif", fontSize: '34px', fontWeight: 700, color: 'var(--text)' },
  titleSpan: { fontStyle: 'italic', color: 'var(--accent)' },
  backBtn: { padding: '10px 20px', background: 'transparent', border: '1px solid var(--divider)', borderRadius: 'var(--r-btn)', fontSize: '12px', color: 'var(--text-2)', cursor: 'pointer', letterSpacing: '0.06em', textTransform: 'uppercase' },
  calWrap: { background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', padding: '28px', marginBottom: '24px' },
  calNav: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' },
  calMonth: { fontFamily: "'Inter', sans-serif", fontSize: '20px', fontWeight: 700, color: 'var(--text)' },
  calNavBtn: { padding: '6px 14px', border: '1px solid var(--divider)', borderRadius: 'var(--r-btn)', background: 'transparent', cursor: 'pointer', fontSize: '14px', color: 'var(--text-3)' },
  calGrid: { display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px' },
  calDayLabel: { textAlign: 'center', fontSize: '11px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-2)', padding: '6px 0', marginBottom: '4px' },
  calDay: { aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 'var(--r-btn)', cursor: 'pointer', fontSize: '13px', fontWeight: 500, border: '1.5px solid transparent', transition: 'all 0.15s', position: 'relative' },
  calDayEmpty: { cursor: 'default' },
  calDayPast: { color: 'rgba(37,28,25,0.2)', cursor: 'not-allowed' },
  calDayHasSlots: { background: 'rgba(200,146,42,0.1)', borderColor: 'var(--accent)', color: 'var(--text)', fontWeight: 700 },
  calDaySelected: { background: 'var(--text)', borderColor: 'var(--text)', color: '#FAF7F2' },
  calDayToday: { borderColor: 'var(--accent)' },
  slotsPanel: { background: 'var(--surface)', border: '1px solid var(--divider)', borderRadius: 'var(--r-card)', padding: '28px' },
  slotsPanelTitle: { fontSize: '11px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '16px' },
  slotDate: { fontFamily: "'Inter', sans-serif", fontSize: '18px', fontWeight: 700, color: 'var(--text)', marginBottom: '16px' },
  horariosGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px', marginBottom: '20px' },
  horarioBtn: { padding: '10px', border: '1.5px solid var(--divider)', borderRadius: 'var(--r-btn)', background: 'transparent', fontSize: '13px', fontWeight: 500, color: 'var(--text-3)', cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s' },
  horarioBtnActive: { background: 'var(--text)', borderColor: 'var(--text)', color: '#FAF7F2' },
  saveBtn: { padding: '12px 28px', background: 'var(--accent)', color: 'var(--btn-text)', border: 'none', borderRadius: 'var(--r-btn)', fontSize: '13px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: 'pointer' },
  clearBtn: { padding: '12px 20px', background: 'transparent', border: '1px solid rgba(229,57,53,0.3)', color: '#E53935', borderRadius: 'var(--r-btn)', fontSize: '13px', cursor: 'pointer', marginLeft: '8px' },
  saved: { padding: '10px 14px', background: 'rgba(76,175,80,0.08)', border: '1px solid rgba(76,175,80,0.3)', color: '#2E7D32', borderRadius: 'var(--r-btn)', fontSize: '13px', marginBottom: '16px' },
  hint: { fontSize: '13px', color: 'var(--text-2)', lineHeight: 1.6, marginBottom: '16px' },
  dot: { position: 'absolute', bottom: '3px', right: '4px', width: '5px', height: '5px', borderRadius: '50%', background: 'var(--accent)' },
};

const DIAS = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

export default function Disponibilidade() {
  const { disponibilidade, salvarDisponibilidade } = useData();
  const navigate = useNavigate();
  const hoje = new Date();
  const [mes, setMes] = useState(hoje.getMonth());
  const [ano, setAno] = useState(hoje.getFullYear());
  const [diaSelecionado, setDiaSelecionado] = useState(null);
  const [horariosSelecionados, setHorariosSelecionados] = useState([]);
  const [salvo, setSalvo] = useState(false);

  function getDiasDoMes() {
    const primeiroDia = new Date(ano, mes, 1).getDay();
    const totalDias = new Date(ano, mes + 1, 0).getDate();
    const dias = [];
    for (let i = 0; i < primeiroDia; i++) dias.push(null);
    for (let d = 1; d <= totalDias; d++) dias.push(d);
    return dias;
  }

  function toKey(dia) {
    return `${ano}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
  }

  function isPast(dia) {
    const d = new Date(ano, mes, dia);
    d.setHours(23, 59, 59);
    return d < hoje;
  }

  function isToday(dia) {
    return dia === hoje.getDate() && mes === hoje.getMonth() && ano === hoje.getFullYear();
  }

  function handleDia(dia) {
    if (!dia || isPast(dia)) return;
    const key = toKey(dia);
    setDiaSelecionado(dia);
    setHorariosSelecionados(disponibilidade[key] || []);
    setSalvo(false);
  }

  function toggleHorario(h) {
    setHorariosSelecionados(hs => hs.includes(h) ? hs.filter(x => x !== h) : [...hs, h].sort());
  }

  function salvar() {
    if (!diaSelecionado) return;
    salvarDisponibilidade(toKey(diaSelecionado), horariosSelecionados);
    setSalvo(true);
    setTimeout(() => setSalvo(false), 2500);
  }

  function limpar() {
    setHorariosSelecionados([]);
    if (diaSelecionado) salvarDisponibilidade(toKey(diaSelecionado), []);
  }

  function navMes(dir) {
    let nm = mes + dir, na = ano;
    if (nm < 0) { nm = 11; na--; }
    if (nm > 11) { nm = 0; na++; }
    setMes(nm); setAno(na);
    setDiaSelecionado(null);
  }

  const dias = getDiasDoMes();

  function diaStyle(dia) {
    if (!dia) return { ...s.calDay, ...s.calDayEmpty };
    if (isPast(dia)) return { ...s.calDay, ...s.calDayPast };
    const key = toKey(dia);
    const hasSlots = (disponibilidade[key] || []).length > 0;
    const selected = diaSelecionado === dia;
    if (selected) return { ...s.calDay, ...s.calDaySelected };
    if (hasSlots) return { ...s.calDay, ...s.calDayHasSlots };
    if (isToday(dia)) return { ...s.calDay, ...s.calDayToday };
    return { ...s.calDay, background: '#FAF7F2' };
  }

  const dataFormatada = diaSelecionado
    ? new Date(ano, mes, diaSelecionado).toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })
    : null;

  // Dias com horários configurados, ordenados
  const diasConfigurados = Object.entries(disponibilidade)
    .filter(([, slots]) => slots && slots.length > 0)
    .sort(([a], [b]) => a.localeCompare(b));

  function formatDiaResumo(key) {
    const [y, m, d] = key.split('-').map(Number);
    return new Date(y, m-1, d).toLocaleDateString('pt-BR', { weekday:'short', day:'numeric', month:'short' });
  }

  return (
    <AdminLayout>
      <div style={s.header}>
        <h1 style={s.title}>Disponibilidade <span style={s.titleSpan}>para Avaliações</span></h1>
        <button style={s.backBtn} onClick={() => navigate('/admin/agendamentos')}>← Voltar</button>
      </div>

      <p style={s.hint}>
        Clique nos dias do calendário para definir os horários disponíveis para avaliação física. Os dias com horários configurados aparecem destacados em dourado.
      </p>

      {salvo && <div style={s.saved}>✓ Disponibilidade salva!</div>}

      <div style={s.calWrap}>
        <div style={s.calNav}>
          <button style={s.calNavBtn} onClick={() => navMes(-1)}>←</button>
          <div style={s.calMonth}>{MESES[mes]} {ano}</div>
          <button style={s.calNavBtn} onClick={() => navMes(1)}>→</button>
        </div>
        <div style={s.calGrid}>
          {DIAS.map(d => <div key={d} style={s.calDayLabel}>{d}</div>)}
          {dias.map((dia, idx) => {
            const key = dia ? toKey(dia) : null;
            const hasSlots = key && (disponibilidade[key] || []).length > 0;
            return (
              <div key={idx} style={diaStyle(dia)} onClick={() => dia && handleDia(dia)}>
                {dia}
                {hasSlots && dia !== diaSelecionado && <div style={s.dot} />}
              </div>
            );
          })}
        </div>
      </div>

      {diaSelecionado && (
        <div style={s.slotsPanel}>
          <div style={s.slotsPanelTitle}>Horários disponíveis</div>
          <div style={s.slotDate}>{dataFormatada}</div>
          <div style={s.horariosGrid}>
            {HORARIOS.map(h => (
              <button
                key={h}
                style={{ ...s.horarioBtn, ...(horariosSelecionados.includes(h) ? s.horarioBtnActive : {}) }}
                onClick={() => toggleHorario(h)}
              >
                {h}
              </button>
            ))}
          </div>
          <button style={s.saveBtn} onClick={salvar}>Salvar disponibilidade</button>
          {horariosSelecionados.length > 0 && (
            <button style={s.clearBtn} onClick={limpar}>Limpar dia</button>
          )}
        </div>
      )}
      {diasConfigurados.length > 0 && (
        <div style={{ background:'var(--surface)', border:'1px solid var(--divider)', borderRadius:'20px', padding:'24px', marginTop:'20px', boxShadow:'var(--sh-card)' }}>
          <div style={{ fontSize:'10px', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', color:'var(--accent)', marginBottom:'16px' }}>
            Dias configurados ({diasConfigurados.length})
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
            {diasConfigurados.map(([key, slots]) => (
              <div key={key} style={{ display:'flex', alignItems:'flex-start', gap:'12px', padding:'12px', background:'var(--surface-2)', borderRadius:'var(--r-btn)', flexWrap:'wrap' }}>
                <div style={{ fontSize:'13px', fontWeight:600, color:'var(--text)', minWidth:'140px' }}>
                  {formatDiaResumo(key)}
                </div>
                <div style={{ display:'flex', flexWrap:'wrap', gap:'6px' }}>
                  {slots.map(h => (
                    <span key={h} style={{ padding:'3px 10px', background:'var(--accent)', color:'var(--btn-text)', borderRadius:'100px', fontSize:'12px', fontWeight:600 }}>{h}</span>
                  ))}
                </div>
                <button
                  onClick={() => { salvarDisponibilidade(key, []); }}
                  style={{ marginLeft:'auto', background:'transparent', border:'none', color:'var(--text-2)', cursor:'pointer', fontSize:'12px', padding:'2px 6px' }}
                >
                  ✕ Remover
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

    </AdminLayout>
  );
}
